import { show, hide, toggle } from 'slidetoggle';

document.addEventListener('DOMContentLoaded', function() {
    let accordions = document.querySelectorAll('accordion-block');
    accordions.forEach(function(accordion) {
        console.info(accordion.dataset);
        let open = accordion.dataset.firstOpen;
        let allowAll = accordion.dataset.allOpen;
        accordion.querySelectorAll('accordion-item-title-wrapper').forEach((title) => {
            title.addEventListener('click', (event) => {
                event.target.closest('accordion-block').querySelectorAll('accordion-item-block').forEach((el) => {
                    if (el.querySelector('accordion-item-title-wrapper') == event.target) {
                        el.classList.toggle('open');
                        toggle(el.querySelector('accordion-item-content-wrapper'), {
                            miliseconds: 200,
                        });
                    }
                    else {
                        if (allowAll == 'false') {
                            el.classList.remove('open');
                            hide(el.querySelector('accordion-item-content-wrapper'), {
                                miliseconds: 200,
                            });
                        };
                    }
                });
            });
        });
        accordion.querySelectorAll('accordion-item-content-wrapper').forEach((el) => el.style.display = 'none');
        if (open == 'true') {
            accordion.querySelector('accordion-item-block').classList.add('open');
            show(accordion.querySelector('accordion-item-content-wrapper'), {
                miliseconds: 200,
            });
        }
    });
});